import createLucideIcon from '../createLucideIcon';

const Command = createLucideIcon('CommandIcon', [
  [
    'path',
    {
      d: 'M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z',
      key: 'uqkaba',
    },
  ],
]);

export default Command;
